import ActionTypes from '../constants';

const initialState = {
    coverages: {},
    coverage: {}
    // loading: false,
};

const coverageReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETCOVERAGESUCCESS:
            return {
                ...state,
                coverages: action.payload,
            }
        case ActionTypes.GETCOVERAGEBYIDSUCCESS:
            return {
                ...state,
                coverage: action.payload,
            }
        default:
            return state;
    }
}

export default coverageReducer;